import * as React from 'react';
import { Props } from './types';
import { arePropsEqual } from './utils';

const Info = React.memo(
  ({ className, altText }: Props) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 14 14"
      className={className}
      data-testid="info-icon"
      stroke="none"
      strokeWidth="1"
      fill="#FFFFFF"
      fillRule="nonzero"
      opacity="1"
    >
      <title>{altText}</title>
      <path
        id="a"
        d="M7 1.007A5.994 5.994 0 111.006 7a6.001 6.001 0 015.993-5.994H7zM7 0a7 7 0 100 14A7 7 0 007 0zm0 4.831c-.716 0-1.028-.297-1.028-1 0-.69.311-.987 1.028-.987.73 0 1.028.298 1.028.987 0 .703-.298 1-1.028 1zm-.865 5.793V5.958h1.73v4.666h-1.73z"
      />
    </svg>
  ),
  arePropsEqual
);

export default Info;
